<template>
  <div class="home">
    <WhollyGuacamole/>
  </div>
</template>

<script>
// @ is an alias to /src
import WhollyGuacamole from '@/components/WhollyGuacamole.vue'

export default {
  name: 'Home',
  components: {
    WhollyGuacamole
  }
}
</script>
